<template>
  <div>
    <ul class="tovar_list">
      <li
        v-for="product in products"
        :key="product.id"
        :class="{
          wide: $store.getters.imagesStyle !== $store.getters.IMAGES_VERTICAL,
        }"
      >
        <ProductListItem
          v-if="$store.getters.outletSettings.delivery_type !== 4"
          :product="product"
        />
        <ResourceItem
          v-if="$store.getters.outletSettings.delivery_type === 4"
          :product="product"
        />
      </li>
      <InfiniteLoading
        v-if="enableInfinite"
        style="width: 100%"
        :distance="0"
        :spinner="'spiral'"
        @infinite="infiniteHandler"
      >
        <div slot="spinner"></div>
      </InfiniteLoading>
    </ul>

    <div v-if="loading">
      <ul class="tovar_list">
        <li v-for="index in 2" :key="index">
          <a class="tl_block">
            <div class="tl_img">
              <div
                class="placeholder shine"
                style="display: block; padding-top: 230px"
              >
                <div class="tl_price" style="width: 40px"></div>
              </div>
            </div>
            <div
              class="tl_name shine"
              style="
                border-radius: 4px;
                width: 80px;
                height: 16px;
                display: block;
              "
            ></div>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<style scoped>
li.wide {
  width: 100%;
}

.cl_img img {
  -webkit-user-drag: none;
}

div.placeholder {
  width: 100%;
  height: 0;
  position: relative;
  border-radius: 16px;
}
</style>

<script>
import CategoryItem from "@/components/ECommerce/Categories/CategoryItem";
import ProductListItem from "@/components/ECommerce/Products/ProductListItem";
import InfiniteLoading from "vue-infinite-loading";
import { FETCH_PRODUCTS, FETCH_SEARCH } from "@/store/actions.type";
import ResourceItem from "@/components/Default/Resource/ResourceItem";

const MODE_CATEGORY = 0;
const MODE_POPULAR = 1;
const MODE_SEARCH = 2;

export default {
  name: "ProductList",
  data() {
    return {};
  },
  props: {
    products: Array,
    mode: Number,
  },
  components: { ResourceItem, ProductListItem, CategoryItem, InfiniteLoading },
  watch: {},
  mounted() {},
  computed: {
    loading() {
      if (this.mode === MODE_CATEGORY) {
        return (
          this.products &&
          this.$store.getters.products[this.$store.getters.selectedCategory.id]
            .meta &&
          this.$store.getters.products[this.$store.getters.selectedCategory.id]
            .meta.loading === true
        );
      }
      if (this.mode === MODE_POPULAR) {
        return (
          this.products &&
          this.$store.getters.popularProducts.meta &&
          this.$store.getters.popularProducts.meta.loading === true
        );
      }
      if (this.mode === MODE_SEARCH) {
        return (
          this.products &&
          this.$store.getters.search.products.meta &&
          this.$store.getters.loading.fetchSearch
        );
      }
    },
    enableInfinite() {
      if (this.mode === MODE_CATEGORY) {
        return (
          this.products &&
          this.$store.getters.products[this.$store.getters.selectedCategory.id]
            .meta &&
          this.$store.getters.products[this.$store.getters.selectedCategory.id]
            .meta.loaded !== true
        );
      }
      if (this.mode === MODE_POPULAR) {
        return (
          this.products &&
          this.$store.getters.popularProducts.meta &&
          this.$store.getters.popularProducts.meta.loaded !== true
        );
      }
      if (this.mode === MODE_SEARCH) {
        return (
          this.products &&
          this.$store.getters.search.products.meta &&
          this.$store.getters.search.products.meta.loaded !== true &&
          !this.$store.getters.loading.fetchSearch
        );
      }
    },
  },
  methods: {
    async infiniteHandler(state) {
      if (this.mode === MODE_CATEGORY) {
        await this.$store
          .dispatch(FETCH_PRODUCTS, {
            category_id: this.$store.getters.selectedCategory.id,
            page: this.$store.getters.products[
              this.$store.getters.selectedCategory.id
            ].meta.next_page,
          })
          .then(() => {
            if (
              this.$store.getters.products[
                this.$store.getters.selectedCategory.id
              ].meta.next_page === null
            ) {
              state.complete();
            } else {
              state.loaded();
            }
          });
      }

      if (this.mode === MODE_POPULAR) {
        await this.$store
          .dispatch(FETCH_PRODUCTS, {
            category_id: 0,
            page: this.$store.getters.popularProducts.meta.next_page,
          })
          .then(() => {
            if (this.$store.getters.popularProducts.meta.next_page === null) {
              state.complete();
            } else {
              state.loaded();
            }
          });
      }

      if (this.mode === MODE_SEARCH) {
        await this.$store
          .dispatch(FETCH_SEARCH, {
            categories: this.loadedCategories,
            page: this.$store.getters.search.products.meta.next_page,
            query: this.$store.getters.search.query,
            only_products: true,
          })
          .then(() => {
            if (this.$store.getters.popularProducts.meta.next_page === null) {
              state.complete();
            } else {
              state.loaded();
            }
          });
      }
    },
  },
};
</script>
